module.exports = __webpack_public_path__ + "img/newModelWorker.2b141482.png";